import { render, staticRenderFns } from "./AddClassAttendance.vue?vue&type=template&id=98ce8e30&scoped=true"
import script from "./AddClassAttendance.vue?vue&type=script&lang=js"
export * from "./AddClassAttendance.vue?vue&type=script&lang=js"
import style0 from "./AddClassAttendance.vue?vue&type=style&index=0&id=98ce8e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ce8e30",
  null
  
)

export default component.exports